import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, Search } from "lucide-react";

function SearchSelect({ label, value, items, onPick, onQuery, testid, placeholder }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  useEffect(() => { onQuery?.(q); }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = onQuery ? items : items.filter((i) => i.label.toLowerCase().includes(q.toLowerCase()));
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testid} className="h-11 w-full px-3 rounded-md border border-slate-300 bg-white text-sm text-left flex items-center gap-2">
          <span className="text-[11px] font-mono uppercase text-slate-500 shrink-0">{label}</span>
          <span className="flex-1 truncate font-semibold">{value || placeholder}</span><ChevronDown className="w-4 h-4 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-2 w-[300px]" align="start">
        <div className="relative mb-2"><Search className="w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2 text-slate-400" />
          <input autoFocus data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca…" className="w-full h-9 pl-8 pr-2 rounded border text-sm" /></div>
        <div className="max-h-72 overflow-y-auto">
          {shown.map((i) => (
            <button key={i.id} data-testid={`${testid}-opt-${i.id}`} onClick={() => { onPick(i); setOpen(false); setQ(""); }} className="w-full text-left px-2 py-1.5 rounded text-sm hover:bg-slate-100 flex justify-between gap-2">
              <span>{i.label}</span>{i.n != null && <span className="text-slate-400 text-xs">{i.n}</span>}
            </button>
          ))}
          {!shown.length && <p className="text-xs text-slate-500 p-2">Nessun risultato</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export function PrinterPicker({ brand, setBrand, printer, setPrinter }) {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [mq, setMq] = useState("");
  useEffect(() => { api.get("/admin/compat/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/compat/models", { params: { brand: brand?.b || "", q: mq } }).then((r) => setModels(r.data)).catch(() => {}), 150);
    return () => clearTimeout(t);
  }, [brand, mq]);
  const bItems = [{ id: "", label: "Tutte le marche" }, ...brands.map((b) => ({ id: b.b || "none", label: b.label, n: b.n, b: b.b }))];
  return (
    <>
      <SearchSelect label="Marca" testid="compat-brand-select" value={brand?.label || "Tutte"} items={bItems}
        onPick={(i) => { setBrand(i.id ? { ...i, b: i.b ?? "" } : null); setPrinter(null); }} />
      <SearchSelect label="Modello" testid="compat-model-select" placeholder="Tutti i modelli" value={printer?.label} onQuery={setMq}
        items={models.map((m) => ({ ...m, label: brand ? m.model : m.label }))} onPick={(m) => setPrinter(m)} />
    </>
  );
}
